import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconThirdParty = ({
  title = "Third party",
  color = "gray",
  viewBoxWidth = 32,
  viewBoxHeight = 32,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g id="IconThirdParty" fill="none" fillRule="evenodd">
      <circle
        id="Oval-Third-Party"
        fill={uiColorToBaseColor(color)}
        cx="16"
        cy="16"
        r="16"
      />
      <g
        id="Icon-/-Integration"
        transform="translate(5.894737, 5.894737)"
        fill="#FFFFFF"
        fillRule="nonzero"
      >
        <path
          d="M13,5 C15.7614237,5 18,7.23857625 18,10 C18,12.7614237 15.7614237,15 13,15 C11.8744479,15 10.8357599,14.6280908 10.0001199,14.0004563 C9.16465739,14.6279413 8.12577817,15 7,15 C4.23857625,15 2,12.7614237 2,10 C2,7.23857625 4.23857625,5 7,5 C8.12577817,5 9.16465739,5.37205867 10.0003836,5.999922 C10.8357599,5.37190923 11.8744479,5 13,5 Z M7,6 C4.790861,6 3,7.790861 3,10 C3,12.209139 4.790861,14 7,14 C7.81656487,14 8.59393073,13.7556895 9.25113937,13.3071793 C8.47169297,12.4249986 8,11.2675842 8,10 C8,8.73241663 8.47169237,7.57500291 9.24912641,6.69370954 L9.39972954,6.79943102 C8.71244805,6.28309106 7.87899665,6 7,6 Z M13,6 C12.1834599,6 11.4064176,6.24428404 10.7496288,6.69290008 C11.5282135,7.57477183 12,8.73229009 12,10 C12,11.2677099 11.5282135,12.4252282 10.7506408,13.3065544 L10.6006737,13.2008719 C11.287882,13.717022 12.1211778,14 13,14 C15.209139,14 17,12.209139 17,10 C17,7.790861 15.209139,6 13,6 Z"
          id="Combined-Shape"
        />
      </g>
    </g>
  </Svg.Icon>
)

export default IconThirdParty
